export enum ViewType {
    LIST_ACTION_VIEW = 'LAV',
}
